(() => {
  const STORAGE_KEY = 'stass-vat-display';

  function setVatMode(mode) {
    mode = mode === 'inc' ? 'inc' : 'exc';

    document.documentElement.dataset.stassVat = mode;
    localStorage.setItem(STORAGE_KEY, mode);

    document.querySelectorAll('[data-vat-mode]').forEach((button) => {
      const active = button.dataset.vatMode === mode;

      button.classList.toggle('is-active', active);
      button.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
  }

  const savedMode =
    localStorage.getItem(STORAGE_KEY) === 'inc' ? 'inc' : 'exc';

  setVatMode(savedMode);

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-vat-mode]');

    if (!button) return;

    setVatMode(button.dataset.vatMode);
  });
})();